import styled, { createGlobalStyle } from "styled-components";
import { Button as BsButton, Card as BsCard } from "react-bootstrap";

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 98px 16px;
    }
  }
`;

export const Wrapper = styled.div`
  /* Tabs */
  .nav-tabs {
   position: sticky;
   top: 80px;
   z-index: 1000;
   background: white; /* importante para não ficar transparente */
  }

  @media (max-width: 575px) {
    .nav-tabs {
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
    }

    .nav-tabs::-webkit-scrollbar {
      display: none;
    }

    .nav-tabs .nav-item {
      flex-shrink: 0;
    }
  }

`;

export const Card = styled(BsCard)`
  && {
    border: 0;
    border-radius: 12px;
    box-shadow: 0 10px 18px rgba(0,0,0,.06);
  }
`;

export const SaveButton = styled(BsButton)`
  && {
    border: 2px solid #0056a6;   
    color: #0056a6;
    font-weight: 750;            
    border-radius: 8px;          
    padding: 6px 20px;      
    margin-right: 12px;     
    background: transparent;
  }

  &&:hover,
  &&:focus {
    background: #0056a6;
    color: #fff;
  }

  &&:disabled,
  &&.disabled {
    opacity: 1;
    cursor: not-allowed;
  }

  @media (max-width: 575px) {
    && {
      margin: 0;
      padding: 6px 8px;
    }
  }
`;

export const UploadButton = styled(BsButton)`
  && {
    background: #a0d6ff;
    border: 1px solid #a0d6ff;
    color: #01579e;
    font-weight: 750;
    border-radius: 4px;
    padding: 4px 16px;
    box-shadow: 0 2px 0 rgba(0,0,0,.02);
  }
  &&:hover, &&:focus {
    background: #1b66c6;
    border-color: #185ab0;
    color: #fff;
  }
`;

export const PublishButton = styled(BsButton)`
  /* só muda o visual quando estiver desabilitado */
  font-weight: 750;
  && {
    white-space: nowrap;
    padding: 6px 20px;
  }
  &&[disabled] {
    background: #c4c5c6;
    border-color: #c4c5c6;
    color: white;
  }
  &&:disabled,
  &&.disabled {
    opacity: 1; /* sem opacidade no desabilitado */
  }
  @media (max-width: 575px) {
    && {
      padding: 6px 8px;
    }
  }
`;


export const BackButton = styled(BsButton)`
  && {
    border: 2px solid #0056a6;   
    color: #0056a6;
    font-weight: 750;            
    border-radius: 8px;          
    padding: 6px 20px;      
    background: transparent;
  }

  &&:hover,
  &&:focus {
    background: #0056a6;
    color: #fff;
  }

  &&:disabled,
  &&.disabled {
    opacity: 1; /* sem opacidade no desabilitado */
    cursor: not-allowed;
  }

  @media (max-width: 575px) {
    && {
      padding: 6px 8px;
    }
  }
`;